import { PlaceholderPage } from "@/components/placeholder/PlaceholderPage";
import { ClipboardList } from "lucide-react";
import { MainLayout } from "@/components/MainLayout";

export default function BeautyClinicsProceduresPage() {
  return (
<MainLayout>
    <PlaceholderPage
      title="Procedimentos"
      description="Gerencie os procedimentos realizados na clínica."
      icon={ClipboardList}
    />
  
    </MainLayout>);
}

